import { useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";

import type { AppDispatch } from "../../store";
import { toggleMobileModeState } from "../../store/slices/appGeneralSlice";

const MOBILE_BREAKPOINT_PX = 768;

const useSyncMobileMode = () => {
    const dispatch = useDispatch<AppDispatch>();

    const setCurrentMobileMode = useCallback(() => {
        dispatch(toggleMobileModeState({
            isMobileView: window.innerWidth < MOBILE_BREAKPOINT_PX,
        }));
    }, [dispatch]);

    const debouncedMobileModeHandler = useMemo(() => (
        debounce(setCurrentMobileMode, 100)
    ), [setCurrentMobileMode]);

    useEffect(() => {
        setCurrentMobileMode();
        window.addEventListener("resize", debouncedMobileModeHandler);

        return () => {
            window.removeEventListener("resize", debouncedMobileModeHandler);
            debouncedMobileModeHandler.cancel();
        };
    }, [debouncedMobileModeHandler, setCurrentMobileMode]);
};

export default useSyncMobileMode;
